import React from 'react';

import { Grid } from '../../../common/components/Grid/Grid';
import {
  GridColumn,
  GridCountFunction,
  GridGetterFunction,
  GridRecord,
} from '../../../common/components/Grid/GridDataTypes';
import { GetTooltipDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import { useTranslation } from '../../../common/hooks/useTranslation';

const stripHtml = (text: string) => text.replace(/<[^>]*>/g, '');

interface TooltipSearchProps {
  getData: GridGetterFunction;
  getCount: GridCountFunction;
  onRowClick: (id: string) => Promise<void> | void;
  refresh?: boolean;
}

export const tooltipForGrid = (tooltip: GetTooltipDto): GridRecord => ({
  key: tooltip.id,
  values: {
    'tooltip.key': tooltip.key,
    'tooltip.description': tooltip.description,
    'tooltip.plText': stripHtml(tooltip.plText),
    'tooltip.enText': stripHtml(tooltip.enText),
  },
});

export const TooltipSearch: React.FC<TooltipSearchProps> = props => {
  const { t, tk } = useTranslation('administrationLng');

  const columns: GridColumn[] = [
    {
      header: t(tk.tooltips.tooltipKey),
      property: 'tooltip.key',
    },
    {
      header: t(tk.tooltips.tooltipDescription),
      property: 'tooltip.description',
    },
    {
      header: t(tk.tooltips.tooltipPlText),
      property: 'tooltip.plText',
      noSorting: true,
    },
    {
      header: t(tk.tooltips.tooltipEnText),
      property: 'tooltip.enText',
      noSorting: true,
    },
  ];

  return (
    <Grid
      getData={props.getData}
      getDataCount={props.getCount}
      columns={columns}
      showFilter={true}
      initialOrderColumn="tooltip.key"
      initialOrderDirection="ASC"
      availablePageSizes={[10, 20, 50]}
      emptyGridMessage={t(tk.tooltips.noTooltips)}
      onRowClick={props.onRowClick}
      refresh={props.refresh}
      withFilterInColumns={true}
      showExport={true}
    />
  );
};
